import { hasFacebookQuery, hasGoogleAnalytics } from './analytics';
import { RouteLocation } from 'vue-router';
import { useMixpanel } from '@utils/composables/use-mixpanel';

export const pageViewed = (to: RouteLocation): void => {
	const { trackMixpanelView } = useMixpanel(to);
	if (!to.meta?.suppressDefaultMxpViewEvent) {
		trackMixpanelView('Page');
	}

	if (hasGoogleAnalytics()) {
		window.ga('send', 'pageview');
	}

	if (hasFacebookQuery()) {
		window.fbq('track', 'PageView');
	}
};
